var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section2" },
    [
      _c("entry-fee-filter"),
      _vm._v(" "),
      _c("div", { staticClass: "filtersection" }, [
        _c("div", { staticClass: "user-filter" }, [
          _c("canvas", {
            staticClass: "canvasElement",
            attrs: { id: "canvasElement", height: "1" },
          }),
          _vm._v(" "),
          _c("canvas", {
            staticClass: "canvasElement",
            attrs: { id: "canvasElement2", height: "1" },
          }),
          _vm._v(" "),
          _c("p", { ref: "better_than" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.current_standing.better_than === "winner"
                    ? _vm.translations.you_are_winner
                    : _vm.translations.better_than_label &&
                        _vm.translations.better_than_label.replace(
                          /%perc%/,
                          _vm.current_standing.better_than
                        )
                ) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sliderWrapper", attrs: { id: "sliderWrapper" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "hammer",
                      rawName: "v-hammer:tap",
                      value: _vm.sliderClick,
                      expression: "sliderClick",
                      arg: "tap",
                    },
                  ],
                  staticClass: "innerSlider",
                  staticStyle: { "pointer-events": "none" },
                  attrs: { id: "innerSlider" },
                },
                [
                  _c(
                    "span",
                    {
                      ref: "separator_1",
                      staticClass: "levels level-2 change-top",
                      staticStyle: { left: "calc(83.3333% - 20px)" },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.translations.top_1_per))])]
                  ),
                  _vm._v(" "),
                  _c("span", {
                    ref: "separator_2",
                    staticClass: "levels level-3",
                    staticStyle: { left: "calc(91.6667% - 20px)" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "levels level-4 change-top",
                    staticStyle: { left: "100%" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "hammer",
                          rawName: "v-hammer:pan",
                          value: _vm.onPan,
                          expression: "onPan",
                          arg: "pan",
                        },
                        {
                          name: "hammer",
                          rawName: "v-hammer:panend",
                          value: _vm.onPanEnd,
                          expression: "onPanEnd",
                          arg: "panend",
                        },
                      ],
                      staticClass: "innerObj",
                      staticStyle: { display: "none" },
                      attrs: { id: "innerObj" },
                    },
                    [
                      _c("element-tag"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "ele_info",
                          staticClass: "bubble-speech",
                          staticStyle: { display: "none" },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                (_vm.current_standing.better_than &&
                                  _vm.translations.speech_bubble[
                                    _vm.current_standing.better_than
                                  ]) ||
                                  "CONFIDENCE SET TO: BEAT EVERYONE"
                              ) +
                              "\n              "
                          ),
                          _c(
                            "svg",
                            {
                              ref: "bubble_pointer",
                              staticClass: "bubble-pointer",
                              attrs: {
                                id: "OBJECTS",
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 50 50",
                              },
                            },
                            [
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  d: "M19.13,7.46C23.29,27.23,1,42.54,1,42.54,36.37,40.31,46.33,19.2,49,7.76Z",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }